const getters = {
  onlinetests: state => state.onlinetest,
};

export default getters;
